(function() {
  /*!
    override option_select.js method to ensure color is before size
  */
  Shopify.OptionSelectors.prototype.replaceSelector = function(domId) {
    var oldSelector = document.getElementById(domId);
    var parent = oldSelector.parentNode;
    Shopify.each(this.buildSelectors().reverse(), function(el) {
      parent.insertBefore(el, oldSelector);
    });
    oldSelector.style.display = 'none';
    this.variantIdField = oldSelector;
  };


  LivifySwatch = {
    colorOptionIdx: productJSON[0].options.indexOf("Color"),
    sizeOptionIdx: productJSON[0].options.indexOf("Size"),

    findProductByID: function(productID) {
      var currentProduct = productJSON.find(function(product) {
        return product.id === productID;
      });
      return currentProduct;
    },

    inStockSizes: function(product) {
      var sizeOptionIdx = this.sizeOptionIdx;

      return $.map(product.variants.filter(function(item) { return item.available;}), function(variant) {
        return variant["option" + (sizeOptionIdx+1)];
      });
    },

    createSizeSwatchesFromSelect: function($el, selectID, product) {
      var active, classes;
      var sizes = $el.find("option").map(function() { return $(this).val(); });

      if (product) {
        var inStock = this.inStockSizes(product);
      } else {
        console.error("could not find product " + product.id);
      }

      var selected = $el.find("option:selected").val();
      var swatches = $.map(sizes, function(size) {
        classes = "swatch";

        if (size === selected) {
          classes += " active";
        }

        if (inStock.indexOf(size) == -1) {
          classes += " out-of-stock";
        }

        return "<div class='" + classes + "' data-value='" + size + "' data-selector-id='" + selectID + "'>" + size + "</div>";
      });

      var $container = $('<div>').addClass('swatch-container size');

      return $container.append(swatches);
    },

    createSizeSwatchesForProduct: function(product) {
      var selectID = 'product-select-'+ product.id + 'product-option-' + this.sizeOptionIdx;
      var $sizeSelect = $('#' + selectID);

      if ($sizeSelect.length == 0) {
        selectID = 'product-select-'+ product.id + product.section_id + '-option-' + this.sizeOptionIdx;
        $sizeSelect = $('#' + selectID);
      }

      if ($sizeSelect.length == 0) {
        console.error("could not find size selector ", selectID)
        return;
      }

      $sizeSelect.hide();
      $sizeSelect.after(this.createSizeSwatchesFromSelect($sizeSelect, selectID, product));
    },

    createColorSwatchesFromSelect: function($el, productID, colors) {
      var active, classes;

      var selected = $el.find("option:selected").val();
      var swatches = $.map(Object.keys(colors), function(color) {
        active = color === selected;
        classes = active ? "swatch active" : "swatch";

        return "<div class='" + color.toLowerCase().replace('/','-') + " " + classes + "' data-value='" + color + "'" + ">" + color + "</div>";
      });

      var $container = $('<div>').addClass('swatch-container color').attr('data-product-id', productID);

      return $container.append(swatches);
    },

    createColorSwatchesForProduct: function(product)  {
      if (product === null) {
        console.error("createColorSwatchesForProduct: PRODUCT NOT FOUND");
        return;
      }

      var colorOptionIdx =  product.options.indexOf("Color");
      var sizeOptionIdx = product.options.indexOf("Size");

      if (colorOptionIdx == -1) {
        console.log("No colour option for product ", product.id);
        return;
      }

      var selectID = '#product-select-' + product.id + product.section_id + '-option-' + colorOptionIdx;

      var $colorSelect = $(selectID);

      if ($colorSelect.length == 0) {
        console.log("lets try findind a quick view product");
        $colorSelect = $(selectID);
      }

      if ($colorSelect.length == 0) {
        console.error("could not find a color selector", selectID);
        return;
      }

      var currentColor;
      $colorSelect.hide();

      currentColor = product.variants[0][colorOptionIdx+1];
      $colorSelect.after(this.createColorSwatchesFromSelect($colorSelect, product.id, product.colors));
    }
  }
})();


$(function() {
  $('body').on("click", ".swatch-container.color .swatch", function(e) {
    var $swatch = $(this);

    var productID = $swatch.parent('.swatch-container').data('product-id')

    var product = LivifySwatch.findProductByID(productID);
    console.log("The current productID is " +  productID + " and the current product is", product);
    var clickedColor = $(this).data('value');

    if (product) {
      var colorOption =  "option" + (product.options.indexOf("Color") + 1);
      var currentColor = product.variants[0][colorOption];
    } else {
      console.log("could not find product")
    }

    e.preventDefault();
    if (clickedColor !== currentColor) {
      if (productJSON.length > 1) {
        console.log("we are on a collection");
        var idx = null;
        var related = product.related[clickedColor];
        console.log("clicked on ", clickedColor);
        console.log("clicked on related", related);

        for (var i = 0; i < productJSON.length; i++) {
          if (productJSON[i].id == related) {
            idx = i
            console.log("we have a winner", idx);
          }
        }

        if (idx) {
          console.log("The related product is ", productJSON[idx]);
          console.log("the idx is ", idx);
          $.fancybox.jumpto(idx);
        }

        return;
      } else {
        window.location = product.colors[clickedColor];
      }
    }
    $(this).closest('.swatch-container.color').find('.swatch').removeClass('active');
    $(this).addClass('active');
  });

  $('body').on("click", ".swatch-container.size .swatch", function(e) {
    e.preventDefault();
    var $swatch = $(this);
    var size = $swatch.data('value');
    var selectorID = $swatch.data('selector-id')
    var $sizeSelect = $('#' + selectorID);

    $sizeSelect.val(size);
    $swatch.closest('.swatch-container').find('.swatch').removeClass('active');
    $swatch.addClass('active');

    $sizeSelect.trigger('change');
  });
});
